import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';

interface IChatConnectionFallbackProps {
    message?: string;
    onBackPress?: () => void;
}

export const ChatConnectionFallback: React.FC<IChatConnectionFallbackProps> = ({
    message,
    onBackPress
}) => {
    const navigation = useNavigation<any>();
    const { t } = useTranslation();

    const handleBackPress = () => {
        if (onBackPress) {
            onBackPress();
        } else {
            navigation.goBack();
        }
    };

    return (
        <View className="flex-1 justify-center items-center px-8">
            <Text className="font-bold mb-6">
                {message || t('commons.connection.connectionRequired')}
            </Text>
            <TouchableOpacity
                className="bg-primary-700 rounded-lg py-4 items-center mb-3 w-full"
                onPress={handleBackPress}>
                <Text className="text-white text-[17px] font-semibold">
                    {t('buttons.back')}
                </Text>
            </TouchableOpacity>
        </View>
    );
};
